var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import ForcJournalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import { DfgLoinc, RacLoinc } from "core/models/bio-exam-result";
import { validateNumber, validatePresence } from "ember-changeset-validations/validators";
import { lookupValidator } from "validated-changeset";
let BaseKfreEditionForm = (_class = class BaseKfreEditionForm extends ForcJournalEventBasedComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
    _defineProperty(this, "journalEventProperties", ["age", "dfg", "rac", "occurredAt", "score"]);
    _defineProperty(this, "isComputingScore", false);
    _initializerDefineProperty(this, "selectedTabButton", _descriptor2, this);
    _defineProperty(this, "validator", o => {
      return lookupValidator(this.currentValidations)(o);
    });
  }
  onTabButtonClicked() {
    this.selectedTabButton = this.selectedTabButton === "first" ? "second" : "first";
  }
  get changeset() {
    const changeset = super.changeset;
    changeset.on("afterValidation", () => {
      if (!this.isComputingScore && this.canComputeScore(this.changeset)) {
        this.isComputingScore = true;
        this.changeset.set("score", this.computeScore(this.changeset));
        this.isComputingScore = false;
      }
    });
    return changeset;
  }
  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      const dfgResult = this.args.patient.getLastBioExamResultWithDate(DfgLoinc);
      const racResult = this.args.patient.getLastBioExamResultWithDate(RacLoinc);
      model.occurredAt = new Date();
      model.age = this.patient.age || model.age;
      model.sex = this.patient.gender;
      model.dfg = dfgResult?.result.value;
      model.dfgOccurredAt = dfgResult?.occurredAt;
      model.rac = racResult?.result.value;
      model.racOccurredAt = racResult?.occurredAt;
      model.score = this.canComputeScore(model) ? this.computeScore(model) : "";
    }
    return model;
  }
  get racDateLabel() {
    const racDate = this.changeset.get("racOccurredAt");
    return racDate ? `Le ${this.intl.formatDate(racDate)}` : "";
  }
  get dfgDateLabel() {
    const dfgDate = this.changeset.get("dfgOccurredAt");
    return dfgDate ? `Le ${this.intl.formatDate(dfgDate)}` : "";
  }
  get isDirty() {
    return super.isDirty || this.isNewMode && this.canComputeScore(this.changeset);
  }
  canComputeScore(o) {
    return ["age", "sex", "dfg", "rac"].every(key => o[key]);
  }
  get score() {
    return this.canComputeScore(this.changeset) ? this.computeScore(this.changeset) : "";
  }
  get surveyValidations() {
    return {
      age: validatePresence({
        presence: true,
        description: "L'age"
      }),
      sex: validatePresence({
        presence: true,
        description: "Le sexe"
      }),
      dfg: [validatePresence({
        presence: true,
        description: "Le dernier DFG"
      }), validateNumber({
        positive: true,
        description: "Le dernier DFG"
      })],
      rac: [validatePresence({
        presence: true,
        description: "Le dernier RAC"
      }), validateNumber({
        positive: true,
        description: "Le dernier RAC"
      })]
    };
  }
  get totalValidations() {
    return {
      score: [validatePresence({
        presence: true,
        description: "Le total"
      }), validateNumber({
        lte: 100,
        positive: true,
        description: "Le total"
      })],
      occurredAt: validatePresence({
        presence: true,
        description: "La date"
      })
    };
  }
  get validations() {
    return {
      ...this.surveyValidations,
      ...this.totalValidations
    };
  }
  get currentValidations() {
    return this.selectedTabButton == "first" ? this.surveyValidations : this.totalValidations;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedTabButton", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "first";
  }
}), _applyDecoratedDescriptor(_class.prototype, "onTabButtonClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTabButtonClicked"), _class.prototype), _class);
export { BaseKfreEditionForm as default };